// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { PlanCancellationOperationsService } from '../generated/api/planCancellationOperations.service';

@Injectable({ providedIn: 'root' })
export class PlanCancellationOperationsClientService {
  constructor(private readonly client: PlanCancellationOperationsService) {}
  // <generated-client-wrappers:methods>
  approve(
    planChangeId: string,
    request: WrapperApi.PlanChangeRecoveryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanChangeCancellationReceipt> {
    if (!this.client)
      throw new Error('PlanCancellationOperationsService is not available');
    return this.client.planCancellationOperationsApprove(
      planChangeId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    planChangeId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanChangeCancellationReview> {
    if (!this.client)
      throw new Error('PlanCancellationOperationsService is not available');
    return this.client.planCancellationOperationsGet(
      planChangeId,
      'body',
      reportProgress,
      options,
    );
  }

  getRetries(
    planChangeId: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanChangeCancellationRetryPage> {
    if (!this.client)
      throw new Error('PlanCancellationOperationsService is not available');
    return this.client.planCancellationOperationsGetRetries(
      planChangeId,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  retry(
    planChangeId: string,
    request: WrapperApi.PlanChangeRecoveryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanChangeCancellationRetryReceipt> {
    if (!this.client)
      throw new Error('PlanCancellationOperationsService is not available');
    return this.client.planCancellationOperationsRetry(
      planChangeId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
